import React from 'react';
import { NavLink } from 'react-router-dom';
import { ShoppingBag, MessageCircle, Package } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/admin', label: 'Orders', icon: ShoppingBag, end: true, testid: 'admin-tab-orders' },
  { to: '/admin/inquiries', label: 'Inquiries', icon: MessageCircle, testid: 'admin-tab-inquiries' },
  { to: '/admin/products', label: 'Products', icon: Package, testid: 'admin-tab-products' },
];

export const AdminTabs = () => {
  return (
    <div className="border-b border-border bg-card">
      <div className="max-w-6xl mx-auto px-4 flex items-center gap-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                'inline-flex items-center gap-2 px-4 py-3 text-sm border-b-2 -mb-px transition-colors',
                isActive
                  ? 'border-foreground text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              )
            }
            data-testid={tab.testid}
          >
            <tab.icon className="w-4 h-4" />
            {tab.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default AdminTabs;
